import type { JSX } from "preact";
import rawLogoSvg from "../assets/images/predictor-logo.svg";

export interface PredictorBrandIconProps {
  className?: string;
}

export function PredictorBrandIcon({
  className,
}: PredictorBrandIconProps): JSX.Element {
  return (
    <span
      aria-hidden="true"
      className={className}
      // eslint-disable-next-line react/no-danger -- inlined bundled asset, no user input
      dangerouslySetInnerHTML={{ __html: rawLogoSvg }}
      style={{ display: "block", lineHeight: 0 }}
    />
  );
}
